import React, { useState } from 'react';
import { Typography, Container, Grid, Box, TextField, InputAdornment, Paper, TableContainer, Table, TableHead, TableBody, TableRow, TablePagination } from "@mui/material";
import { Tabs, Tab } from '@mui/material';
import { styled } from '@mui/material/styles';
import { AntTabs, AntTab, StyledTableCell, StyledTableRow} from '../tabs_style';
import { useNavigate } from 'react-router-dom';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import SearchIcon from '@mui/icons-material/Search';

export default function TablaDeInteresROAnterior({ nombre, apellido, modulo }) {
  const [tabIndex, setTabIndex] = React.useState(1);
  const navigate = useNavigate();

  const handleChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const validarSoloNumeros = (event) => {
    // Obtener el valor actual del campo
    let valor = event.target.value;
    // Reemplazar todos los caracteres no numéricos, excepto el primer punto
    valor = valor.replace(/[^\d.]/g, '');
    // Asegurarse de que solo haya un punto decimal
    valor = valor.replace(/^(\d*\.\d*)\..*$/, '$1');
    // Actualizar el valor del campo
    event.target.value = valor;
  };

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [pageEdad, setPageEdad] = useState(0);
  const [rowsPerPageEdad, setRowsPerPageEdad] = useState(5);
  const [pageTasa, setPageTasa] = useState(0);
  const [rowsPerPageTasa, setRowsPerPageTasa] = useState(5);
  const [searchTerm, setSearchTerm] = useState('');

  // Obtener el año actual
  const añoActual = new Date().getFullYear();

  // Generar filas adicionales desde el año 2022 hasta el año actual
  const filasAdicionales = [];
  for (let año = 2022; año <= añoActual; año++) {
    filasAdicionales.push({ year: año, factor: '' });
  }

  // Combinar las filas originales con las filas adicionales
  const rows = [
    { year: 1970, factor: '0.00%' },
    { year: 1971, factor: '0.00%' },
    { year: 1972, factor: '0.00%' },
    { year: 1973, factor: '0.00%' },
    { year: 1974, factor: '0.00%' },
    { year: 1975, factor: '0.00%' },
    { year: 1976, factor: '-1.74%' },
    { year: 1977, factor: '0.53%' },
    { year: 1978, factor: '2.91%' },
    { year: 1979, factor: '3.33%' },
    { year: 1980, factor: '4.50%' },
    { year: 1981, factor: '5.78%' },
    { year: 1982, factor: '7.40%' },
    { year: 1983, factor: '7.64%' },
    { year: 1984, factor: '8.60%' },
    { year: 1985, factor: '8.90%' },
    { year: 1986, factor: '5.88%' },
    { year: 1987, factor: '8.00%' },
    { year: 1988, factor: '7.44%' },
    { year: 1989, factor: '8.30%' },
    { year: 1990, factor: '8.89%' },
    { year: 1991, factor: '10.99%' },
    { year: 1992, factor: '12.80%' },
    { year: 1993, factor: '10.05%' },
    { year: 1994, factor: '9.58%' },
    { year: 1995, factor: '11.41%' },
    { year: 1996, factor: '11.69%' },
    { year: 1997, factor: '9.17%' },
    { year: 1998, factor: '10.43%' },
    { year: 1999, factor: '9.63%' },
    { year: 2000, factor: '7.61%' },
    { year: 2001, factor: '9.81%' },
    { year: 2002, factor: '8.73%' },
    { year: 2003, factor: '9.34%' },
    { year: 2004, factor: '8.41%' },
    { year: 2005, factor: '7.57%' },
    { year: 2006, factor: '5.79%' },
    { year: 2007, factor: '4.74%' },
    { year: 2008, factor: '5.93%' },
    { year: 2009, factor: '5.50%' },
    { year: 2010, factor: '4.50%' },
    { year: 2011, factor: '5.66%' },
    { year: 2012, factor: '7.00%' },
    { year: 2013, factor: '7.34%' },
    { year: 2014, factor: '7.82%' },
    { year: 2015, factor: '6.28%' },
    { year: 2016, factor: '4.55%' },
    { year: 2017, factor: '4.25%' },
    { year: 2018, factor: '4.13%' },
    { year: 2019, factor: '4.02%' },
    { year: 2020, factor: '4.33%' },
    { year: 2021, factor: '3.70%' },
    ...filasAdicionales,
  ];

  const rowsEdad = [
    { edadCumplida: 54, edadJubilacion: 58, tiempoServicio: 10 },
    { edadCumplida: 53, edadJubilacion: 58, tiempoServicio: 10 },
    { edadCumplida: 52, edadJubilacion: 59, tiempoServicio: 12 },
    { edadCumplida: 51, edadJubilacion: 59, tiempoServicio: 12 },
    { edadCumplida: 50, edadJubilacion: 60, tiempoServicio: 12 },
    { edadCumplida: 49, edadJubilacion: 60, tiempoServicio: 13 },
    { edadCumplida: 48, edadJubilacion: 60, tiempoServicio: 13 },
    { edadCumplida: 47, edadJubilacion: 60, tiempoServicio: 13 },
    { edadCumplida: 46, edadJubilacion: 61, tiempoServicio: 14 },
    { edadCumplida: 45, edadJubilacion: 61, tiempoServicio: 14 },
    { edadCumplida: 44, edadJubilacion: 61, tiempoServicio: 14 },
    { edadCumplida: 43, edadJubilacion: 62, tiempoServicio: 15 },
    { edadCumplida: 42, edadJubilacion: 62, tiempoServicio: 15 },
  ];

  const rowsTasa = [
    { rango: '01/07/2015 - 10/08/2015', porcentaje: '7.85%' },
    { rango: '11/08/2015 - 10/09/2015', porcentaje: '6.98%' },
    { rango: '11/09/2015 - 10/10/2015', porcentaje: '6.84%' },
    { rango: '11/09/2015 - 10/11/2015', porcentaje: '6.89%' },
    { rango: '11/10/2015 - 10/11/2015', porcentaje: '6.92%' },
    { rango: '11/11/2015 - 10/12/2015', porcentaje: '6.85%' },
    { rango: '11/12/2015 - 10/01/2016', porcentaje: '6.63%' },
    { rango: '11/01/2016 - 11/02/2016', porcentaje: '6.28%' },
  ];

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangePageEdad = (event, newPage) => {
    setPageEdad(newPage);
  };

  const handleChangeRowsPerPageEdad = (event) => {
    setRowsPerPageEdad(parseInt(event.target.value, 10));
    setPageEdad(0);
  };

  const handleChangePageTasa = (event, newPage) => {
    setPageTasa(newPage);
  };

  const handleChangeRowsPerPageTasa = (event) => {
    setRowsPerPageTasa(parseInt(event.target.value, 10));
    setPageTasa(0);
  };

  const filteredRows = rows.filter(row =>
    row.year.toString().includes(searchTerm) ||
    row.factor.includes(searchTerm)
  );

  return (
    <Grid container direction="column">
      <Container>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <h2>Tabla De Interés</h2>
        </div>
      </Container>
      <Container>
        <Box sx={{ position: 'sticky', top: 0, zIndex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Paper square>
            <AntTabs
              value={tabIndex}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              variant="scrollable"
              scrollButtons="auto"
              TabIndicatorProps={{
                style: { display: 'none' }, // O también puedes usar display: 'none' aquí
            }}
            >
              <AntTab label="Resumen" />
              <AntTab label="Tabla De Interés" />
              <AntTab label="Datos" />
              <AntTab label="Cálculos" />
              <AntTab label="Períodos" />
              <AntTab label="Rebajas" />
              <AntTab label="Comparativa Devolución 10%" />
              <AntTab label="Finiquito y Dictamen" />
            </AntTabs>
          </Paper>
        </Box>

        <Box mt={3}>
          {/* Contenido de la pestaña actual */}
          {tabIndex === 0 && navigate('Separaciones/ResumenROAnterior')}
          {tabIndex === 1}
          {tabIndex === 2 && navigate('/Separaciones/ROantes13demayo2014')}
          {tabIndex === 3 && navigate('/Separaciones/CalculosROAnterior')}
          {tabIndex === 4 && navigate('/Separaciones/PeriodosROAnterior')}
          {tabIndex === 5 && navigate('/Separaciones/RebajasROAnterior')}
          {tabIndex === 6 && navigate('/Separaciones/ComparativaROAnterior')}
          {tabIndex === 7 && navigate('/Separaciones/FiniquitoROAnterior')}
        </Box>
      </Container>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '10px' }}>
        <TextField
          className="form-control mr-sm-2"
          label="Búsqueda"
          onInput={validarSoloNumeros}
          placeholder="Ingrese año o factor anual"
          aria-label="Search"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <div className="row" style={{ marginTop: '20px', display: 'flex', justifyContent: 'center' }}>
        <div style={{ marginRight: '40px' }}>
          <TableContainer component={Paper}>
            {/* Tabla 1 */}
            <Table>
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell style={{ textAlign: 'center' }}><strong>AÑO</strong></StyledTableCell>
                  <StyledTableCell style={{ textAlign: 'center' }}><strong>FACTOR ANUAL</strong></StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {(rowsPerPage > 0
                  ? filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  : filteredRows
                ).map((row) => (
                  <StyledTableRow key={row.year}>
                    <StyledTableCell style={{ textAlign: 'center' }}>{row.year}</StyledTableCell>
                    <StyledTableCell style={{ textAlign: 'center' }}>{row.factor}</StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 30]}
            component="div"
            count={filteredRows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>

        <div>
          <TableContainer component={Paper}>
            {/* Tabla 2 */}
            <Table>
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell style={{ textAlign: 'center', whiteSpace: 'normal' }}><strong>Edad Cumplida<br />en el 2013</strong></StyledTableCell>
                  <StyledTableCell style={{ textAlign: 'center' }}><strong>Edad de Jubilación <br />Voluntaria</strong></StyledTableCell>
                  <StyledTableCell style={{ textAlign: 'center' }}><strong>Tiempo de Servicio <br />Mínimo (Años)</strong></StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {(rowsPerPageEdad > 0
                  ? rowsEdad.slice(pageEdad * rowsPerPageEdad, pageEdad * rowsPerPageEdad + rowsPerPageEdad)
                  : rowsEdad
                ).map((row) => (
                  <StyledTableRow key={row.id}>
                    <StyledTableCell style={{ textAlign: 'center' }}>{row.edadCumplida}</StyledTableCell>
                    <StyledTableCell style={{ textAlign: 'center' }}>{row.edadJubilacion}</StyledTableCell>
                    <StyledTableCell style={{ textAlign: 'center' }}>{row.tiempoServicio}</StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 13]}
            component="div"
            count={rowsEdad.length}
            rowsPerPage={rowsPerPageEdad}
            page={pageEdad}
            onPageChange={handleChangePageEdad}
            onRowsPerPageChange={handleChangeRowsPerPageEdad}
          />
        </div>
      </div>

    </Grid>
  );
}
